import { render, staticRenderFns } from "./ArticleAuthor.vue?vue&type=template&id=12468508&scoped=true&"
import script from "./ArticleAuthor.vue?vue&type=script&lang=js&"
export * from "./ArticleAuthor.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAuthor.vue?vue&type=style&index=0&id=12468508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12468508",
  null
  
)

export default component.exports